module.exports = __webpack_public_path__ + "img/article_5_4.b6785744.png";